import React from 'react';
import { motion } from 'framer-motion';

const Loader = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '40vh' }}>
    <motion.div
      animate={{ rotate: 360 }}
      transition={{ repeat: Infinity, duration: 1.5, ease: 'linear' }}
      style={{
        width: 50, height: 50,
        border: '4px solid #F5D76E',
        borderTop: '4px solid #FF6B00',
        borderRadius: '50%'
      }}
    />
  </div>
);

export default Loader;